import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NewsService } from '../../../services/news.service';
import { PermissionService } from '../../../services/permission.service';
import DynamicDatePipe from '../../../utils/pipes/dynamic-date.pipe';

@Component({
  selector: 'widget-news',
  templateUrl: './widget-news.component.html',
  styleUrls: ['./widget-news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    MatIcon,
    MatTooltipModule,
    RouterLink,
    RouterLinkActive,
    DynamicDatePipe,
    SlicePipe,
  ],
})
export class WidgetNewsComponent {
  public _newsService = inject(NewsService);
  public permissionService = inject(PermissionService);

  public $news = this._newsService.$news;
  public $showingNews = this._newsService.$showingNews;
  public $allNewsArray = this._newsService.$allNewsArray;
}
